import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
} from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { Controller, useForm } from "react-hook-form";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import { InputAdornment } from "@mui/material";
import { useRecordContext } from "react-admin";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function ScoreCard({ onSave, defaultValues, ...props }: any) {
  const record = useRecordContext();
  const sectionName = "scorecard";
  const sectionTitle = "Underwriting Score Card";
  const sectionSubtitle = "";

  // const data = record?.data?.basic?.sectionName;
  const data = record?.data?.basic?.scorecard;
  const scorecardData = data?.scorecardData || {};
  const productType = record?.data?.basic?.type;
  const subType = record?.data?.basic?.subType;
  const division = record?.data?.basic?.division;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const [showDetail, setShowDetail] = React.useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
  } = useForm({
    mode: "onBlur",
    defaultValues: defaultValues || {},
  });
  React.useEffect(() => {
    if (data) {
      reset({
        // sAutoRemoval: data.sAutoRemoval || "NO",
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = sectionName;
    // console.log("Form data:", formData);
    let score_card_checkbox: string[] = [];
    Object.keys(formData).forEach((key) => {
      if (key.endsWith("_checkbox") && formData[key]) {
        score_card_checkbox.push(key.replace("_checkbox", ""));
      }
    });

    let saveFormData: { [key: string]: any } = {};
    saveFormData.saveAction = sectionName;
    saveFormData["score_card_checkbox"] = score_card_checkbox;

    if (score_card_checkbox) {
      //循环score_card_checkbox
      score_card_checkbox.forEach((mainkey) => {
        // 如果有scorelevel，则添加到formData中
        let scorelevelArr: any[] = [];
        let scoreLevelStartArr: any[] = [];
        let scoreLevelEndArr: any[] = [];
        //查找formData中是否有对应的key+ "_level_score_xxx",如果有则放入数组中
        Object.keys(formData).forEach((key) => {
          if (key.endsWith("_weight")) {
            saveFormData[`${mainkey}_weight`] = formData[key];
          }
          if (key.startsWith(`${mainkey}_level_score_score_`)) {
            scorelevelArr.push(formData[key]);
          }
          if (key.startsWith(`${mainkey}_level_score_start_`)) {
            scoreLevelStartArr.push(formData[key]);
          }
          if (key.startsWith(`${mainkey}_level_score_end_`)) {
            scoreLevelEndArr.push(formData[key]);
          }
        });

        saveFormData[mainkey + "_level_score"] = scorelevelArr;
        saveFormData[mainkey + "_level_score_start"] = scoreLevelStartArr;
        saveFormData[mainkey + "_level_score_end"] = scoreLevelEndArr;
      });
    }

    saveFormData["score_card_checkbox"] = score_card_checkbox;
    if (onSave) {
      onSave(saveFormData);
    }
  };

  interface ScoreCardCategory {
    id: string;
    name: string;
    category: string;
    weight: string;
    scorelevel?: {};
    // Add other properties if needed
  }

  const ScoreCardCategoryLine = ({
    category,
    control,
  }: {
    category: ScoreCardCategory;
    control: any;
  }) => {
    const [showScoreLevel, setShowScoreLevel] = React.useState(
      category?.weight ? true : false
    );
    const [scoreLevelListNum, setScoreLevelListNum] = React.useState(
      category?.scorelevel?.length || 2
    );

    let category_unit = "";
    // if (strripos(strtolower(category.name), "ratio") !== false) {
    //   category_unit = "%";
    // }
    // if (strripos(strtolower(category.name), "history") !== false) {
    //   category_unit = "Years";
    // }
    if (category?.name.toLowerCase().includes("ratio")) {
      category_unit = "%";
    }
    if (category?.name.toLowerCase().includes("history")) {
      category_unit = "Years";
    }
    //  return (
    //        <IconButton>
    //         <img
    //           src="/public/icon/action-delete.png"
    //           style={{ width: "18px", height: "18px", cursor: "pointer" }}
    //           onClick={props.onClick}
    //         />
    //       </IconButton >
    //       );
    const handleDeleteScoreCard = (index: any) => {
      //删除当前的行，未完成
    };

    return (
      <>
        <Grid
          container
          sx={{ backgroundColor: "#f5f5f5", mt: 2, pt: 1, pb: 1 }}
        >
          <Grid item xs={1} sx={{ pl: 2 }}>
            <Controller
              name={category.id + "_checkbox"}
              control={control}
              defaultValue={category?.weight ? true : false}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value || false}
                      onChange={(e) => {
                        field.onChange(e.target.checked);
                        setShowScoreLevel(e.target.checked);
                      }}
                      // icon={<Check />}
                      // checkedIcon={<Check />}
                    />
                  }
                  label=""
                />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <FieldTitle title={category.name} />
          </Grid>
          <Grid item xs={7} sx={{ "& input": { backgroundColor: "#fff" } }}>
            {/* small int number, category.weight */}
            <Controller
              name={`${category.id}_weight`}
              control={control}
              defaultValue={category.weight || ""}
              render={({ field }) => (
                <CustomProductIntTextField small {...field} />
              )}
            />
          </Grid>
        </Grid>
        {showScoreLevel && (
          <Grid container>
            <Grid item xs={12}>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={3}>
                    <FieldTitle title="Score" />
                  </Grid>
                  <Grid item xs={3}>
                    <FieldTitle title="Level Bottom Threshold" />
                  </Grid>
                  <Grid item xs={3}>
                    <FieldTitle title="Level Ceiling Threshold" />
                  </Grid>
                </Grid>
                {/* scoreLevelListNum， 有几个则显示几行，第一行标题显示Highest Score Level, 中间行显示 Middle Score Level, 最后一行显示 Lowest Score Level  */}
                {Array.from({ length: scoreLevelListNum }).map((_, index) => {
                  let curItemValue = category?.scorelevel
                    ? category?.scorelevel[index]
                    : null;
                  return (
                    <Grid container spacing={2} key={index}>
                      <Grid item xs={3}>
                        <FieldTitle
                          title={
                            index === 0
                              ? "Highest Score Level"
                              : index === scoreLevelListNum - 1
                              ? "Lowest Score Level"
                              : "Middle Score Level"
                          }
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Controller
                          name={`${category.id}_level_score_score_${index + 1}`}
                          control={control}
                          // defaultValue={index === 0 ? 100 : 0}
                          defaultValue={
                            curItemValue?.score || (index === 0 ? 100 : 0)
                          }
                          render={({ field }) => (
                            <CustomProductIntTextField
                              {...field}
                              middle
                              // readonly={true} 中间的可编辑
                              readonly={
                                !(
                                  index !== 0 && index !== scoreLevelListNum - 1
                                )
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Controller
                          name={`${category.id}_level_score_start_${index + 1}`}
                          control={control}
                          defaultValue={curItemValue?.score_start || ""}
                          render={({ field }) => (
                            <CustomProductIntTextField
                              {...field}
                              middle
                              endIcon={
                                category_unit ? (
                                  <InputAdornment position="end">
                                    {category_unit}
                                  </InputAdornment>
                                ) : null
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Controller
                          name={`${category.id}_level_score_end_${index + 1}`}
                          control={control}
                          defaultValue={curItemValue?.score_end || ""}
                          render={({ field }) => (
                            <CustomProductIntTextField
                              {...field}
                              middle
                              endIcon={
                                category_unit ? (
                                  <InputAdornment position="end">
                                    {category_unit}
                                  </InputAdornment>
                                ) : null
                              }
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={1}>
                        {index != 0 && index != scoreLevelListNum - 1 && (
                          <IconButton>
                            <img
                              src="/public/icon/action-delete.png"
                              style={{
                                width: "18px",
                                height: "18px",
                                cursor: "pointer",
                              }}
                              onClick={handleDeleteScoreCard(index)}
                            />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>
                  );
                })}
              </Box>
            </Grid>

            <Grid item xs={12}>
              {/* add a button to add more score level */}
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setScoreLevelListNum((prev) => prev + 1);
                }}
                sx={{ mt: 1 }}
              >
                Add Score Level
              </Button>
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  return (
    <SectionStyled id={"section_" + sectionName}>
      <SectionTitle subtitle={sectionSubtitle} title={sectionTitle} />

      <Box sx={{ padding: "10px" }}>
        {productModulesGroup?.includes("score_card") && (
          <>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={3}>
                <FieldTitle title="Minimum Score Threshold" />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="dMinScoreThreshold"
                  defaultValue={data?.dMinScoreThreshold || ""}
                  control={control}
                  render={({ field }) => (
                    <CustomProductIntTextField {...field} small />
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid container sx={{ mt: 2 }}>
                <Grid item xs={5}>
                  <FieldTitle title="Score Categories" />
                </Grid>
                <Grid item xs={7}>
                  <FieldTitle title="Category Weight" />
                </Grid>
              </Grid>
              {Object.entries(scorecardData).map(([key, item]) => (
                <>
                  <ScoreCardCategoryLine
                    category={item as ScoreCardCategory}
                    control={control}
                  />
                </>
              ))}
            </Grid>
            {/* Form Actions */}
            <CustomProductActionBottom>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveClick}
                disabled={!isDirty}
                sx={{ width: "120px", mt: 1 }}
              >
                Save
              </Button>
            </CustomProductActionBottom>
          </>
        )}
      </Box>
    </SectionStyled>
  );
}
